module.exports = __webpack_public_path__ + "static/media/add-icon.c5c8fccc.svg";